import Vue from "vue";
import VueRouter from "vue-router";
import guardRoute from "@/commons/authGuard";
import { localStorageKeys } from '@/commons/storage-keys.ts'
// Routes
import AccountRoutes from "./modules/Account";
import RequestListRoutes from "./modules/RequestList";
import RequestDisconnectRoutes from "./modules/RequestDisconnect";
// import NotFound from "./modules/NotFound";

Vue.use(VueRouter);

const routes = [
  { path: "/", redirect: "/request" },
  {
    path: "/api-docs",
    name: "api-docs",
    component: () =>
      import(/* webpackChunkName: "MainLayout" */ "@/views/Docs/MISAGatewayDocs.vue"),
    meta: {
      Title: "Tài liệu tích hợp misa payment gateway",
    },
  },

  ...AccountRoutes,
  {
    path: "/request",
    component: () =>
      import(/* webpackChunkName: "MainLayout" */ "@/layouts/MainLayout.vue"),
    beforeEnter: (to, from, next) => {
      guardRoute(to, from, next, "Request", "View");
    },
    children: [
      ...RequestListRoutes,
      ...RequestDisconnectRoutes,

      { path: "", redirect: "request-list" },
      { path: "**", redirect: "request-list" },
    ],
  },

  { path: "**", redirect: "/login" },
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (((!localStorage.getItem(localStorageKeys.TOKEN) || !localStorage.getItem(localStorageKeys.USER_INFO)) && to.name !== 'Login') && to.name!=="api-docs") {
    next({ name: 'Login' })
  } else {
    next()
  }
})

export default router;
